import {
  Notification,
  Breadcrumb,
  BreadcrumbItem,
  Option,
  CheckboxGroup,
  CheckboxButton,
  Alert,
  Dialog
} from 'element-ui'
import { mapState } from 'vuex'

import Icon from 'vue-awesome/components/Icon.vue'
import 'vue-awesome/icons/map'
import 'vue-awesome/icons/th-list'
import 'vue-awesome/icons/area-chart'

import ResultList from '@/components/Result/ResultList/ResultList.vue'
import ResultMap from '@/components/Result/ResultMap.vue'
import ResultChart from '@/components/Result/ResultChart/ResultChart.vue'
import TableExhibitorDetail from '@/components/Result/Tables/TableExhibitorDetail.vue'
import ExhibitionCatalog from '@/components/ExhibitionCatalog/ExhibitionCatalog'
import mapFR from '../../lang/fr_FR/map'
import mapEN from '../../lang/en_GB/map'

import {
  SEARCH_EXHIBITION_LIST,
  SEARCH_EXHIBITION_MAP,
  SEARCH_EXHIBITION_PERIOD,
  SEARCH_EXHIBITOR_LIST,
  SEARCH_EXHIBITOR_MAP,
  SEARCH_EXHIBITOR_PERIOD,
  SEARCH_EXHIBITED_WORK_LIST,
  SEARCH_EXHIBITED_WORK_MAP,
  SEARCH_EXHIBITED_WORK_PERIOD
} from '@/store/search/constants'

const transformFilters = (urlFilters) => {
  if (!urlFilters) return []
  try {
    let jsonFilters = JSON.parse(urlFilters)
    if (Array.isArray(jsonFilters)) {
      return jsonFilters.map((currentFilter) => {
        if (currentFilter[2] === '') {
          return false
        }
        // special cases for enum fields, gender & countries
        if (currentFilter[0] === 'gender' || currentFilter[0] === 'exhibition_group_title' || currentFilter[0].includes('country')) {
          return {
            property: currentFilter[0],
            matchType: currentFilter[1],
            value: currentFilter[2]
          }
        }
        return {
          property: currentFilter[0],
          matchType: currentFilter[1],
          value: currentFilter[2].toLowerCase()
        }
      })
    }
  } catch (error) {
    console.warn('Bad json in transformFilters: ', urlFilters)
  }
  return []
}

export default {
  name: 'result',
  data () {
    return {
      display: ['list', 'map'],
      orderOptions: [
        { label: 'Année d\'exposition', value: 'begin_year' },
        { label: 'Titre d\'exposition', value: 'title' },
        { label: 'Ville', value: 'city' }
      ]
    }
  },
  computed: {
    ...mapState({
      glossary: state => state.glossary,
      query: state => state.route.query,
      search: state => state.search,
      period: state => state.search.resultsPeriod,
      dialog: state => state.dialog
    }),
    jsonFilters: function () {
      return transformFilters(this.$route.query.filters)
    }
  },
  methods: {
    fetchData () {
      const {
        type,
        value,
        order,
        direction,
        page,
        itemsPerPage,
        collection,
        begin,
        end
      } = this.$route.query

      const jsonFilters = this.jsonFilters
      switch (type) {
        case undefined:
          break
        case 'exhibitor':
          this.$store.dispatch('search/' + SEARCH_EXHIBITOR_LIST, {
            value, order, direction, page, itemsPerPage, collection, begin, end, jsonFilters
          })
          this.$store.dispatch('search/' + SEARCH_EXHIBITOR_MAP, {
            value, begin, end, jsonFilters
          })
          this.$store.dispatch('search/' + SEARCH_EXHIBITOR_PERIOD, {
            value, jsonFilters
          })
          break
        case 'exhibited_work':
          this.$store.dispatch('search/' + SEARCH_EXHIBITED_WORK_LIST, {
            value, order, direction, page, itemsPerPage, collection, begin, end, jsonFilters
          })
          this.$store.dispatch('search/' + SEARCH_EXHIBITED_WORK_MAP, {
            value, begin, end, jsonFilters
          })
          this.$store.dispatch('search/' + SEARCH_EXHIBITED_WORK_PERIOD, {
            value, jsonFilters
          })
          break
        case 'exhibition':
          this.$store.dispatch('search/' + SEARCH_EXHIBITION_LIST, {
            value, order, direction, page, itemsPerPage, collection, begin, end, jsonFilters
          })
          this.$store.dispatch('search/' + SEARCH_EXHIBITION_MAP, {
            value, collection, begin, end, jsonFilters
          })
          this.$store.dispatch('search/' + SEARCH_EXHIBITION_PERIOD, {
            value, collection, jsonFilters
          })
          break
      }
    },
    getLayout (el) {
      const layoutContains = (e) => {
        return this.display.indexOf(e) !== -1
      }
      switch (this.display.length) {
        case 1:
          if (this.display[0] === el) {
            if (el === 'graph') {
              return 'full-height column-100'
            }
            return 'column-100'
          }
          return 'hide'
        case 2:
          if (!layoutContains(el)) {
            return 'hide'
          }
          if (!layoutContains('list')) {
            return 'column-100'
          }
          if (el === 'graph') {
            return 'full-height column-50'
          }
          return 'column-50'
        case 3:
          return 'column-50'
        default:
          return 'hide'
      }
      // return this.display.length === 1 && this.display.indexOf(el) !== -1
    },
    showInfo () {
      const isFirstVisit = sessionStorage.getItem('showInfo')
      if (isFirstVisit === null) {
        Notification.info({
          duration: 10000,
          title: 'Info',
          message: this.$t('map.message.limit')
        })
        sessionStorage.setItem('showInfo', 'true')
      }
    }
  },
  created () {
    this.fetchData()

    this.showInfo()
  },
  watch: {
    '$route': 'fetchData'
  },
  components: {
    ResultList,
    ResultMap,
    ResultChart,
    elBreadcrumb: Breadcrumb,
    elBreadcrumbItem: BreadcrumbItem,
    elOption: Option,
    elCheckboxGroup: CheckboxGroup,
    elCheckboxButton: CheckboxButton,
    elAlert: Alert,
    Icon,
    elDialog: Dialog,
    TableExhibitorDetail,
    ExhibitionCatalog
  }
}



// WEBPACK FOOTER //
// ./src/components/Result/Result.js